import axios from 'axios';

class FlavorService {
    // Servicios para Categorías de Gustos
    static async getFlavorCategories(filters = {}) {
        const { status, name } = filters;
        const params = {};
        if (status !== undefined) params.status = status;
        if (name) params.name = name;

        return axios.get(process.env.REACT_APP_API_FLAVOR_CATEGORIES_ROUTE, {
            params,
            withCredentials: true
        });
    }

    static async getFlavorCategoriesPage(page = 0, size = 10, sortBy = 'id', sortDirection = 'ASC', filters = {}) {
        return axios.get(process.env.REACT_APP_API_FLAVOR_CATEGORIES_PAGE_ROUTE, {
            params: {
                page,
                size,
                sortBy,
                sortDirection,
                ...filters
            },
            withCredentials: true
        });
    }

    static async getFlavorCategoryById(id) {
        return axios.get(`${process.env.REACT_APP_API_FLAVOR_CATEGORIES_ROUTE}/${id}`, {
            withCredentials: true
        });
    }

    static async createFlavorCategory(category) {
        return axios.post(process.env.REACT_APP_API_FLAVOR_CATEGORIES_ROUTE, category, {
            withCredentials: true
        });
    }

    static async updateFlavorCategory(id, category) {
        return axios.put(`${process.env.REACT_APP_API_FLAVOR_CATEGORIES_ROUTE}/${id}`, category, {
            withCredentials: true
        });
    }

    static async deleteFlavorCategory(id) {
        return axios.delete(`${process.env.REACT_APP_API_FLAVOR_CATEGORIES_ROUTE}/${id}`, {
            withCredentials: true
        });
    }

    static async toggleFlavorCategoryStatus(id, enable) {
        const endpoint = enable ? 'enable' : 'disable';
        return axios.put(`${process.env.REACT_APP_API_FLAVOR_CATEGORIES_ROUTE}/${id}/${endpoint}`, {}, {
            withCredentials: true
        });
    }

    // Servicios para Gustos
    static async getFlavors(filters = {}) {
        const { status, name, flavorCategoryId } = filters;
        const params = {};
        if (status !== undefined) params.status = status;
        if (name) params.name = name;
        if (flavorCategoryId) params.flavorCategoryId = flavorCategoryId;

        return axios.get(process.env.REACT_APP_API_FLAVORS_ROUTE, {
            params,
            withCredentials: true
        });
    }

    static async getFlavorsPage(page = 0, size = 10, sortBy = 'id', sortDirection = 'ASC', filters = {}) {
        return axios.get(process.env.REACT_APP_API_FLAVORS_PAGE_ROUTE, {
            params: {
                page,
                size,
                sortBy,
                sortDirection,
                ...filters
            },
            withCredentials: true
        });
    }

    static async getFlavorById(id) {
        return axios.get(`${process.env.REACT_APP_API_FLAVORS_ROUTE}/${id}`, {
            withCredentials: true
        });
    }

    static async getFlavorsByCategory(categoryId) {
        return axios.get(`${process.env.REACT_APP_API_FLAVORS_ROUTE}/category/${categoryId}`, {
            withCredentials: true
        });
    }

    static async createFlavor(flavor) {
        return axios.post(process.env.REACT_APP_API_FLAVORS_ROUTE, flavor, {
            withCredentials: true
        });
    }

    static async updateFlavor(id, flavor) {
        return axios.put(`${process.env.REACT_APP_API_FLAVORS_ROUTE}/${id}`, flavor, {
            withCredentials: true
        });
    }

    static async deleteFlavor(id) {
        return axios.delete(`${process.env.REACT_APP_API_FLAVORS_ROUTE}/${id}`, {
            withCredentials: true
        });
    }

    static async toggleFlavorStatus(id, enable) {
        const endpoint = enable ? 'enable' : 'disable';
        return axios.put(`${process.env.REACT_APP_API_FLAVORS_ROUTE}/${id}/${endpoint}`, {}, {
            withCredentials: true
        });
    }
}

export default FlavorService;